import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import CakeForm from './CakeForm';
import { api } from '../lib/api';

export default function AdminCakeEdit() {
  const { id } = useParams();
  const [cake, setCake] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getCake(id)
      .then(({ cake }) => setCake(cake))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <AdminLayout title="Edit Cake">
      {loading ? (
        <p style={{ fontFamily: 'var(--font-sans)', color: 'var(--text-mid)' }}>Loading…</p>
      ) : !cake ? (
        <p style={{ fontFamily: 'var(--font-sans)', color: 'var(--text-mid)' }}>Cake not found.</p>
      ) : (
        <CakeForm
          cakeId={id}
          initial={{
            name: cake.name || '',
            category: cake.category || '',
            badge: cake.badge || '',
            price: cake.price ?? '',
            pricePerPound: cake.pricePerPound || '',
            poundSizes: cake.poundSizes || [],
            image: cake.image || '',
            imagePublicId: cake.imagePublicId || '',
            description: cake.description || '',
            longDescription: cake.longDescription || '',
            serves: cake.serves || '',
            weight: cake.weight || '',
            flavours: (cake.flavours || []).join(', '),
            delivery: cake.delivery || '',
            customizable: !!cake.customizable,
            featured: !!cake.featured,
            isAvailable: cake.isAvailable ?? true,
          }}
        />
      )}
    </AdminLayout>
  );
}
